import styles from '../styles/HomePage.module.css';

const HomePage = () => (
  <div className={styles['home-page']}>
    <h2>Welcome to our page!</h2>
    <p>
      Lorem ipsum dolor sit, amet consectetur adipisicing elit.
      Quam sint quisquam minima at eius natus cupiditate.
      Quam corporis qui, cumque dicta molestias iure dolores.
      Vero fuga officiis mollitia eaque aperiam.
      Est laudantium illum optio omnis quibusdam labore at sit dicta
      accusantium.
      Delectus veritatis eaque inventore esse cumque.
      Maiores corrupti labore veniam autem sequi tenetur quia quae.
      Nam voluptatem illum ipsam!
      Inventore atque dolores, commodi molestiae provident quos recusandae facere sequi illum.
      Laboriosam commodi itaque, a minima distinctio officiis.
      Explicabo, itaque maiores rem dolor laboriosam voluptatum non fugiat sint quisquam! Ea!
    </p>
    <p>
      Omnis doloribus accusamus alias dolore distinctio?
      Iusto aliquid, unde nam assumenda saepe, accusamus quo quos inventore
      ipsa aspernatur beatae earum delectus,
      dolores dolorem eaque libero asperiores labore recusandae.
      Non, placeat.
      Impedit repudiandae deserunt doloribus magnam fuga quo saepe labore,
      voluptatem ratione explicabo voluptate ipsum eius aliquid obcaecati
      doloremque!
      Ducimus ex repellendus debitis iusto provident impedit cum, obcaecati
      officiis eius natus.
      Pariatur odio id cumque rerum modi similique commodi odit vitae ipsa rem
      nobis provident architecto ex vero, corporis accusantium harum veniam
      excepturi libero fuga minus consequatur beatae? Nobis, molestias voluptate!
    </p>
  </div>
);

export default HomePage;
